import { render, staticRenderFns } from "./EConteudoAulaRegular.vue?vue&type=template&id=0b85f502&scoped=true"
import script from "./EConteudoAulaRegular.vue?vue&type=script&lang=js"
export * from "./EConteudoAulaRegular.vue?vue&type=script&lang=js"
import style0 from "./EConteudoAulaRegular.vue?vue&type=style&index=0&id=0b85f502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85f502",
  null
  
)

export default component.exports